import COMMON_CONSTANTS from '../constants/commonConstants';

const WORDPRESS_URL = COMMON_CONSTANTS.getWordpressBaseUrl();
const SERVER_URL = process.env.REACT_APP_SERVER_URL || '';
const IS_SERVER_URL_CONFIGURED = process.env.REACT_APP_IS_SERVER_URL_CONFIGURED === 'true' || false;

/**
 * Fetch raw menu data from WordPress API only.
 * Returns the raw API response (not formatted). Used as fallback when primary source fails.
 *
 * @param {string} menuId - Menu identifier
 * @returns {Promise<object|null>} Raw menu data or null on error
 */
export const fetchMenuFromWordPress = async (menuId) => {
  try {
    const wordpressMenuUrl = `${WORDPRESS_URL}/wp-json/menus/v1/menus/${menuId}`;
    const response = await fetch(wordpressMenuUrl);

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`Error fetching data from WordPress:`, error);
    return null;
  }
};

/**
 * Fetch raw menu data from the configured source (Node.js server or WordPress).
 * Falls back to WordPress if the primary source fails.
 * Returns the raw API response (not formatted).
 *
 * @param {string} menuId - Menu identifier
 * @returns {Promise<object|null>} Raw menu data or null on error
 */
export const fetchMenuData = async (menuId) => {
  try {
    const url = IS_SERVER_URL_CONFIGURED
      ? `${SERVER_URL}${COMMON_CONSTANTS.GET_MENU_ENDPOINT}/${menuId}`
      : `${WORDPRESS_URL}/wp-json/menus/v1/menus/${menuId}`;

    const response = await fetch(url);

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`Error fetching menu from configured source:`, error);
    return fetchMenuFromWordPress(menuId);
  }
};
